import(/* webpackMode: "eager", webpackExports: ["BlogPostView"] */ "/vercel/path0/web/web/src/app/blog/[slug]/BlogPostView.tsx");
